var map = {
	"./br/PT/S1/bg_p123.jpg": 21427,
	"./br/PT/S2/bg_p123.jpg": 30377,
	"./br/PT/bg_p123.jpg": 79412,
	"./in/EN/S1/bg_p123.jpg": 41333,
	"./in/EN/S2/bg_p123.jpg": 19197,
	"./in/HI/bg_p123.jpg": 41758,
	"./mx/EN/S1/bg_p123.jpg": 61578,
	"./mx/EN/bg_p123.jpg": 30342,
	"./mx/ES/bg_p123.jpg": 44218,
	"./ng/EN/S1/bg_p123.jpg": 86775,
	"./ng/EN/bg_p123.jpg": 78127,
	"./ph/EN/S1/bg_p123.jpg": 15705,
	"./ph/EN/bg_p123.jpg": 29029,
	"./vn/VI/S1/bg_p123.jpg": 74702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16796;